
        <div class="detail-grid-wrapper">
            <app-cs-ag-grid-js
                [params]="params"
                [config]="params.config"
                (onGridInit)="onGridInit($event)">
            </app-cs-ag-grid-js>
        </div>